/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/
import {createContext} from '@lit/context';

// Unique identifier for the context
// Context object, which acts like a key for the context.
// The context object acts as a key. A consumer will only receive
// values from a provider if their contexts match. A Symbol ensures
// that this context will be unique.
export const storeContextKey = Symbol('redux-store');

// Create a context with default value and Store type

export const storeContext = createContext(storeContextKey);